/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer";
import ListDualText from "../../../../components/_utils/CommonListView/ListSubComponent/ListDualText";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import Loader from "../../../../components/Loader/Index";
import { taxCompliantViewAll } from "../../../../redux/features/accounts/taxAccount/taxAccountViewAll";
import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerListViewAllAcc } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  resetToggle,
  setToggleRemTxn,
} from "../../../../redux/features/reimbursementTransaction";
import { fetchTdsTransactionActionable } from "../../../../redux/features/transactions/taxTransaction/taxTransactionApproval";
import {
  taxTxnNewAddLabel,
  taxTxnRemoveLabel,
  tdsTxnViewAll,
} from "../../../../redux/features/transactions/taxTransaction/taxTransactionViewAll";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import useCategories from "../../../../utils/useCategories";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";

// Retreiving date from url
const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const TaxationTransactionViewAll = (props) => {
  const scrollContainerRef = useRef(null);
  const scrollRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const pageSizeChangedRef = useRef(false);
  const navStateAppliedRef = useRef(false);
  const lifecycleSyncedToUrlRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const categoryMapper = useCategories();
  // Pagination
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams(
    location?.state?.approvalStatus
      ? {
          lifecycle: location.state.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        },
  );

  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));

  // USESTATES
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [hideCarousal, setHideCaroursal] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [mainData, setMainData] = useState([]);
  const [stateName, setStateName] = useState(
    searchParam.get("statename") || "",
  );

  // Label Popup
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);

  // Filters
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");

  // Top summary & label selection
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [labelTransactions, setLabelTransactions] = useState([]);

  // Owner account filter
  const [accountnumberstate, setaccountnumberstate] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    props?.Owner_account_number ? props?.Owner_account_number : "",
  );
  const [ownerAccId, setOwnerAccId] = useState(
    searchParam.get("sourceAcc") ||
      (props?.similarTxnType === "similarTxn" &&
        props?.queryParams?.owner_account_id)
      ? props?.queryParams?.owner_account_id
      : "",
  );

  // Category & label filters
  const [currentCategory, setCurrentCategory] = useState(
    props?.isCategoryName
      ? props?.isCategoryName
      : searchParam.get("category") || "",
  );
  const [labelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [labels, setLabels] = useState([]);

  // Amount & input helpers
  const [txnAmountFilter, setTxnAmountFilter] = useState(
    searchParam.get("amount") ||
      (props?.similarTxnType === "similarTxn" && props?.queryParams?.amount)
      ? props?.queryParams?.amount
      : "",
  );
  const [inputData, setInputData] = useState([]);

  // Date range filters
  const [startDateFilter, setStartDateFilter] = useState(dateFromUrl.start);
  const [endDateFilter, setEndDateFilter] = useState(dateFromUrl.end);

  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    searchParam.get("paymentmethod") || "",
  );

  // Additional account-related filters
  const [currentIfscCode, setCurrentIfscCode] = useState("");
  const [accountNameValue, setAccountNameValue] = useState("");
  const [selectedTaxAccId, setSelectedTaxAccId] = useState(
    props?.txnHistoryid
      ? props?.txnHistoryid
      : searchParam.get("beneAcc") || "",
  );

  const [accountName, setAccountName] = useState(
    props?.TxnHistoryAccountName ? props?.TxnHistoryAccountName : "",
  );
  const [isConfidentialMethod, setIsConfidentialMethod] = useState(
    props?.taxTxnconfidential === "Y"
      ? "Show only confidential" ||
          (props?.similarTxnType === "similarTxn" &&
            props?.queryParams?.confidential_transaction ===
              "Show only confidential")
      : props?.taxTxnconfidential === "N" ||
          (props?.similarTxnType === "similarTxn" &&
            props?.queryParams?.confidential_transaction ===
              "Hide confidential")
        ? "Hide confidential"
        : searchParam.get("confidential") || "",
  );

  // Get the approval status passed from the dashboard or URL
  const initialApprovalStatus =
    location.state?.approvalStatus || searchParam.get("lifecycle") || "all";

  // Status filters (initialized from URL or location.state so filters persist on back)
  const [currentStatus, setCurrentStatus] = useState(
    initialApprovalStatus && initialApprovalStatus !== "all"
      ? initialApprovalStatus.toLowerCase()
      : props?.flow === "Tax_txnViewAll_popup_reject"
        ? "pending"
        : searchParam.get("lifecycle") || "",
  );
  const [currentDistributionStatus, setCurrentDistributionStatus] = useState(
    searchParam.get("distribution") || "",
  );

  const [accumulatedData, setAccumulatedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchdata, SetsearchData] = useState("");
  const [beneAccId, setBeneAccId] = useState("");

  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  // Replace the current static initialization:
  const amountRangeFromUrl = searchParam.get("amountrange");
  const parsedAmountRange = amountRangeFromUrl
    ? (() => {
        const [min, max] = amountRangeFromUrl.split(",");
        return { min: min || "", max: max || "" };
      })()
    : { min: "", max: "" };

  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(
    !!(parsedAmountRange.min && parsedAmountRange.max),
  );
  const [amountLimit, setAmountLimit] = useState(parsedAmountRange);

  // SELECTORS
  const services = useSelector((state) => state.refreshToken.services);
  const { reimbursementTxnViewAllLoading, toggleReimTxn } = useSelector(
    (state) => state.reimbursementTransaction,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  //FUNCTIONS
  const handleAction = async () => {
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          fetchTdsTransactionActionable({
            page_no: currentPage,
            page_size: pageSize,
            category: currentCategory,
          }),
        );

        const newApprovalData = responseApproval?.payload?.transactions || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setTotalBalanceAmount(
          responseApproval?.payload?.total_amount ||
            GlobalConfiguration?.lengthCheckZero,
        );
        setLoading(false);
        if (
          pageSizeChangedRef.current &&
          newApprovalData?.length &&
          isLabelClicked
        ) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newApprovalData.map((t) => t.txn_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);

        let queryParams = {
          page_no: currentPage,
          page_size: pageSize,
          sort_by:
            accountbalancestate === "Oldest first"
              ? "oldest"
              : accountbalancestate === "Amount : Low to high"
                ? "ascending"
                : accountbalancestate === "Amount : High to low"
                  ? "descending"
                  : "latest",
        };

        if (currentStatus) {
          queryParams.lifecycle_status = currentStatus;
        }

        if (currentDistributionStatus) {
          queryParams.distribution_lifecycle_status = currentDistributionStatus;
        }
        if (isConfidentialMethod) {
          queryParams.confidential_transaction = isConfidentialMethod;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (isPaymentMethod) {
          queryParams.payment_method = isPaymentMethod;
        }

        if (ownerAccId && ownerAccId !== "") {
          queryParams.owner_account_id = ownerAccId;
        }

        if (selectedTaxAccId) {
          queryParams.tds_account_id = selectedTaxAccId;
        }

        if (currentIfscCode) {
          queryParams.owner_account_ifsc_code = currentIfscCode;
        }

        if (currentCategory) {
          queryParams.category = currentCategory;
        }

        if (txnAmountFilter) {
          queryParams.amount = txnAmountFilter;
        }
        if (stateName) {
          queryParams.created_via = stateName;
        }
        if (labelSearchText) {
          queryParams.labels = labelSearchText;
        }
        if (searchUserText !== "" && props?.seachType !== "rejectall") {
          queryParams.additional_data = searchUserText;
        }

        queryParams.min_amount = isAmtFilterApplied
          ? amountLimit.min
          : undefined;
        queryParams.max_amount = isAmtFilterApplied
          ? amountLimit.max
          : undefined;

        const response = await dispatch(tdsTxnViewAll(queryParams));
        setMainData(response?.payload);
        const newData = response?.payload?.transactions || [];
        setAccumulatedData(newData);
        setLabels((prev) => {
          const fromApi = response?.payload?.summary?.available_labels || [];
          return Array.from(new Set([...(prev || []), ...fromApi]));
        });
        setLoading(false);
        setTotalBalanceAmount(
          response?.payload?.total_amount ||
            GlobalConfiguration?.lengthCheckZero,
        );
        // When page size was reduced and in label mode, trim selection to only IDs on current page
        if (pageSizeChangedRef.current && newData?.length && isLabelClicked) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newData.map((t) => t.txn_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
        setTotalBalanceAmount(GlobalConfiguration?.lengthCheckZero);
      }
    }
  };

  const onMount = () => {
    dispatch(resetToggle());
  };

  const handleSubmit = (key, value) => {
    if (props.type !== "tax_txnViewAll_popup") {
      handleSearchParams(key, value);
    }
  };

  // Pagination

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
    if (isLabelClicked) {
      setLabelTransactions([]);
    }
  };

  // const handleConfidentialMethod = (selectedConfidential) => {
  //   setIsConfidentialMethod(selectedConfidential);
  // };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    if (value !== pageSize) {
      pageSizeChangedRef.current = true;
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  // Toggle

  const handleToggle = (newToggleValue) => {
    if (toggleReimTxn !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
      dispatch(setToggleRemTxn(newToggleValue));
    }
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const selectableIds = accumulatedData?.map((t) => t.txn_id) || [];

  const hasSelection =
    labelTransactions.length > GlobalConfiguration?.lengthCheckZero;

  const isAllSelectedOnPage =
    selectableIds.length > 0 &&
    selectableIds.every((id) => labelTransactions.includes(id));

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration?.intervalMedium,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      const s = displayDate(start);
      const e = displayDate(end);
      setStartDateFilter(s);
      setEndDateFilter(e);
      handleSubmit("date", `${s},${e}`);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      handleSubmit("date", "");
    }
  };

  // Label Popup

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);

      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids[0]?.errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);

    const res = await dispatch(
      taxTxnNewAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (taxTxnNewAddLabel.fulfilled.match(res)) {
      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...(labelsToAssign || [])])),
      );
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;

      if (taxTxnNewAddLabel.rejected.match(res)) {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }
    setLoading(false);
    if (taxTxnNewAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);

    const res = await dispatch(
      taxTxnRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (taxTxnRemoveLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (taxTxnRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
  };

  // Label Select

  const handleSelectAll = () => {
    if (!accumulatedData?.length) return;

    const allIds = accumulatedData.map((item) => item.txn_id);

    setLabelTransactions((prev) => {
      const isPageFullySelected = allIds.every((id) => prev.includes(id));

      if (isPageFullySelected) {
        return [];
      } else {
        return [...allIds];
      }
    });
  };

  const handleTransactionClick = useCallback(
    (e, context) => {
      if (isLabelClicked) {
        const isAlreadySelected = labelTransactions.includes(context?.txn_id);
        if (isAlreadySelected) {
          setLabelTransactions((prev) =>
            prev.filter((id) => id !== context?.txn_id),
          );
        } else {
          setLabelTransactions((prev) => [...prev, context?.txn_id]);
        }
        return;
      }

      if (context?.txn_id) {
        navigate(
          `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${context.txn_id}`,
          { replace: props.openTransHistory ? true : false },
          {
            state: {
              isViewAll: location.pathname.includes("view_all"),
              currentStatus,
            },
          },
        );
      }

      if (props.type === "tax_txnViewAll_popup") {
        props.closeReimburseTxnDetailsModal();
      }
    },
    [
      navigate,
      location.pathname,
      isLabelClicked,
      labelTransactions,
      props.type,
      currentStatus,
    ],
  );

  // CTA
  const clearParameterVisibility =
    searchdata ||
    !!currentStatus ||
    !!currentDistributionStatus ||
    !!isPaymentMethod ||
    !!currentCategory ||
    !!txnAmountFilter ||
    !!selectedTaxAccId ||
    !!accountnumberstate ||
    !!accountName ||
    !!ownerAccId ||
    !!beneAccId ||
    !!currentIfscCode ||
    !!searchUserTextDebounce ||
    !!searchUserText ||
    !!isConfidentialMethod ||
    !!(startDateFilter && endDateFilter) ||
    !!stateName ||
    !!accountbalancestate ||
    isAmtFilterApplied ||
    (Array.isArray(labelSearchText) &&
      labelSearchText.length > GlobalConfiguration?.lengthCheckZero);

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSearchUserTextDebounce("");
    setSearchUserText("");
    setTxnAmountFilter("");
    setLabelSearchText([]);
    setaccountnumberstate("");
    setOwnerAccId("");
    setBeneAccId("");
    setCurrentIfscCode("");
    setIsPaymentMethod("");
    setStartDateFilter("");
    setIsConfidentialMethod("");
    setEndDateFilter("");
    setisLabelClicked(false);
    setaccountbalancestate("");
    setStateName("");
    setIsAmtFilterApplied(false);
    setAmountLimit({ min: "", max: "" });
    if (props?.flow !== "Tax_txnViewAll_popup_reject") {
      setCurrentStatus("");
    }
    setCurrentDistributionStatus("");
    if (props.type !== "tax_txnViewAll_popup" && !props?.categoryName) {
      setCurrentCategory("");
    }
    if (props.type !== "tax_txnViewAll_popup" && !props?.txnHistoryid) {
      setSelectedTaxAccId("");
    }
    SetsearchData("");
    setAccountName("");
    // Clear URL params in one go so back navigation doesn't restore filters
    if (props.type !== "tax_txnViewAll_popup") {
      const keepPagesize = searchParam.get("pagesize") || dropdownOptions[0];
      navigate(
        {
          pathname: location.pathname,
          search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${keepPagesize}`,
        },
        { replace: true },
      );
    }
  };

  // Status

  const statuses = [
    "approved",
    "require approval",
    "pending",
    "rejected",
    "abandoned",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const taxABeneficiary = services?.includes("ATDSTransaction");

    const taxCBeneficiary = services?.includes("VTDSTransaction");

    const beneficiaryTxn =
      taxCBeneficiary &&
      !taxABeneficiary &&
      !hasAdmin &&
      status === "require approval";

    const txnRequestTxn =
      taxABeneficiary && !taxCBeneficiary && !hasAdmin && status === "pending";

    if (beneficiaryTxn) {
      return false;
    }

    if (txnRequestTxn) {
      return false;
    }

    if (hasAdmin && taxABeneficiary && taxCBeneficiary) {
      return true;
    }

    return true;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      default:
        return "var(--settled)";
    }
  };

  const handleDistributionChange = (selectedLabel) => {
    let statusToSend = "";
    switch (selectedLabel) {
      case "distribution created":
        statusToSend = "created";
        break;
      case "awaiting funds":
        statusToSend = "awaiting_funds";
        break;
      case "distribution initiated":
        statusToSend = "distribution_initiated";
        break;
      case "distribution rejected":
        statusToSend = "rejected";
        break;
      case "distribution complete":
        statusToSend = "distribution_complete";
        break;
      case "distribution abandoned":
        statusToSend = "abandoned";
        break;
      case "distribution approved":
        statusToSend = "distribution_approved";
        break;
      case "distribution pending":
        statusToSend = "distribution_pending";
        break;
      default:
        break;
    }
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    handleSubmit("distribution", statusToSend);
    setCurrentDistributionStatus(statusToSend);
  };

  const getDisplayDistributionStatus = (status = "") => {
    switch (status) {
      case "created":
        return "distribution created";
      case "awaiting_funds":
        return "awaiting funds";
      case "distribution_initiated":
        return "distribution initiated";
      case "rejected":
        return "distribution rejected";
      case "distribution_complete":
        return "distribution complete";
      case "Distribution_approved":
        return "Distribution approved";
      case "Distribution_pending":
        return "Distribution pending";
      case "abandoned":
        return "distribution abandoned";
      case "failed":
        return "failed";
      default:
        return "";
    }
  };

  const getDistributionColor = (distribution_lifecycle_status) => {
    switch (distribution_lifecycle_status) {
      case "created":
        return "var(--queued)";
      case "awaiting_funds":
        return "var(--queued)";
      case "distribution_initiated":
        return "var(--queued)";
      case "distribution_complete":
        return "var(--settled)";
      case "abandoned":
        return "var(--abandoned)";
      case "failed":
        return "var(--queued)";
      case "Distribution_approved":
        return "var(--awaiting)";
      default:
        return "var(--text-primary)";
    }
  };

  // USEEFFECT HOOKS

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  // Redirect

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    stateName,
    currentPage,
    searchUserText,
    isPaymentMethod,
    pageSize,
    ownerAccId,
    accountnumberstate,
    selectedTaxAccId,
    currentStatus,
    currentDistributionStatus,
    startDateFilter,
    endDateFilter,
    currentIfscCode,
    currentCategory,
    txnAmountFilter,
    labelSearchText,
    accountbalancestate,
    isAmtFilterApplied,
    amountLimit,
  ]);

  useEffect(() => {
    if (location.state?.approvalStatus && !navStateAppliedRef.current) {
      setCurrentStatus(location.state.approvalStatus);
      setCurrentDistributionStatus("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      navStateAppliedRef.current = true;
    }
  }, [location.state]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    selectedTaxAccId,
    isPaymentMethod,
    accountNumber,
    txnAmountFilter,
    isConfidentialMethod,
    labelSearchText,
  ]);

  useEffect(() => {
    if (
      props.type === "tax_txnViewAll_popup" ||
      lifecycleSyncedToUrlRef.current
    ) {
      return;
    }
    const statusFromState = location?.state?.approvalStatus;
    if (statusFromState && statusFromState !== "all") {
      const valueToSync = statusFromState.toLowerCase?.() ?? statusFromState;
      handleSearchParams("lifecycle", valueToSync);
      lifecycleSyncedToUrlRef.current = true;
    }
  }, [location?.state?.approvalStatus, props.type, handleSearchParams]);

  useEffect(() => {
    if (location.state?.approvalStatus && !navStateAppliedRef.current) {
      setCurrentStatus(location.state.approvalStatus);
      setCurrentDistributionStatus("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      navStateAppliedRef.current = true;
    }
  }, [location.state]);

  useEffect(() => {
    let response;
    let data;
    setDataLoading(true);
    (async () => {
      switch (active) {
        case "Tax type":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data = response?.payload?.categories?.map((itm) => {
            return {
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            };
          });
          setInputData(data);
          setDataLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          setDataLoading(false);
          break;

        case "Tax account":
          response = await dispatch(
            taxCompliantViewAll({
              search_string: searchUserTextDebounce,
              page_no: GlobalConfiguration.lengthCheckOne,
              page_size: PaginationConfiguration.paginationSmall,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.tds_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          setDataLoading(false);
          break;

        case "Search":
          setSearchUserText(searchUserTextDebounce);
          setDataLoading(false);
          break;

        case "Labels":
          data = labels
            ?.filter((itm) => {
              return itm.includes(searchUserTextDebounce);
            })
            ?.map((val) => {
              return { id: val, Label: val, display: val };
            });
          setInputData(data);
          setDataLoading(false);
          break;

        default:
          setInputData([]);
          setDataLoading(false);
          break;
      }
      setDataLoading(false);
    })();
  }, [active]);

  return (
    <>
      <div
        className={`flex flex-col overflow-hidden bg-primary-bg ${props.type === "tax_txnViewAll_popup" && "relative h-full"}`}
      >
        {accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
          <div
            className={`absolute ${loading && "hidden"} rounded-none ${loading ? "hidden" : "block"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none " : "z-z-index-dropdown"} bottom-bottom-base w-full h-pagination-height  ${
              props?.typepop === "rejectAllTransactionPopup"
                ? "h-auto Qmd:h-status_all_height"
                : "h-pagination-height"
            }`}
          >
            <div
              className={`${
                showInnerSearchBar &&
                "opacity-light-opacity bg-PopUp-BackDrop  pointer-events-none h-full"
              }`}
            >
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={() => {}}
              />
            </div>
          </div>
        )}

        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated transactions."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={labelTransactions}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={accumulatedData
                ?.filter((t) => labelTransactions.includes(t.txn_id))
                ?.map((t) => ({ ...t, id: t.txn_id }))}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}
        {/* Transactions List / Grid */}

        <div
          className={`bg-primary-bg flex flex-col ${props?.type === "tax_txnViewAll_popup" ? "h-full flex-1" : "h-screen"}  `}
          id=" benetxnmain"
        >
          <div className={`transactionHistoryPop_topDiv hidden none `}></div>
          {/* Spacer for navbar / breadcrumb */}
          <div
            className={`Qmd:min-h-navbar-breadcrumb-height ${showInnerSearchBar && "z-z-index-overlay"} ${props?.type === "tax_txnViewAll_popup" && "hidden"} bg-primary-nav`}
          ></div>
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          <div
            className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${props?.type === "tax_txnViewAll_popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
          >
            <TopNavComponent
              topNavHeader={totalBalanceAmount}
              topNavSubText={"Total amount"}
              handleBack={() => {
                if (isLabelClicked) {
                  setisLabelClicked(false);
                } else {
                  navigate(GlobalConfiguration?.navigate_back);
                }
              }}
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(labelTransactions) &&
                        labelTransactions.length >
                          GlobalConfiguration?.lengthCheckZero
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        if (
                          labelTransactions?.length >
                          GlobalConfiguration?.lengthCheckZero
                        ) {
                          setLabelTransactions([]);
                        } else {
                          setisLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                      hoverOption: "white",
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={isLabelClicked}
              isSelectionView={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign Labels",
                      btnType: "button",
                      enabledBgColor: labelTransactions?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (!labelTransactions.length) return;
                        setIsLabelPopupOpen(true);
                      },
                      enabledTextColor: labelTransactions?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                      isDisabled: !labelTransactions?.length,
                      inActiveVariantNeeded: true,
                    }
                  : undefined
              }
              BottomSubText={
                isLabelClicked
                  ? "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions."
                  : ""
              }
              BottomSubTextVaraint="primary"
              selectionText={`Transactions selected: ${labelTransactions.length}`}
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: "Select all",

                      enabledBgColor:
                        !loading && isAllSelectedOnPage
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)",

                      isDisabled:
                        accumulatedData.length ===
                        GlobalConfiguration.lengthCheckZero,

                      handleFunction: (e) => {
                        e.stopPropagation();
                        handleSelectAll();
                      },

                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",

                      icon:
                        !loading && isAllSelectedOnPage
                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                          : ICONS.SELECT_ALL_WHITE_OUTLINE,

                      fullWidthRequired: false,

                      hoverOption: hasSelection ? "black" : "white",
                    }
                  : undefined
              }
              isToggleNeeded={true}
              toggleProps={
                !isLabelClicked
                  ? {
                      state: toggleReimTxn,
                      title: toggleReimTxn ? "Grid View" : "List View",
                      isDisabled: false,
                      handleClick: (e) => {
                        handleToggle(!toggleReimTxn);
                      },
                    }
                  : undefined
              }
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: loading,
                onSearchInput: (val) => setSearchUserTextDebounce(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search tax transaction",
                filterPlaceholder: "additional details",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setSearchUserText(val);
                    },
                    isDropdown: false,
                    isDisabled: false,
                  },
                  {
                    name: "Owner account",
                    short_name: "Own. Acc",
                    isMulti: false,
                    value: ownerAccId,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("sourceAcc", val);
                      setOwnerAccId(val);
                    },
                    setDisplayValue: setAccountNumber,
                    valueType: "string",
                    isDropdown: true,
                    isDisabled: loading ? true : false,
                  },
                  {
                    name: "Tax account ",
                    short_name: "Tax A/c",
                    isMulti: false,
                    value: selectedTaxAccId,
                    displayValue:
                      accountName?.toLowerCase() ||
                      accountNameValue?.toLowerCase(),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("beneAcc", val);
                      setSelectedTaxAccId(val);
                    },
                    setDisplayValue: (val) => {
                      setAccountName(val);
                      setAccountNameValue(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled:
                      props.type === "tax_txnViewAll_popup"
                        ? true
                        : loading
                          ? true
                          : false,
                  },

                  {
                    name: "Tax type",
                    short_name: "Cat",
                    valueType: "string",
                    isMulti: false,
                    value: currentCategory,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("category", val);
                      setCurrentCategory(val);
                    },
                    isDropdown: true,
                    isDisabled: props?.isCategoryName
                      ? true
                      : loading
                        ? true
                        : false,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelSearchText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit(
                        "label",
                        Array.isArray(val) ? val.join(",") : val,
                      );
                      setLabelSearchText(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading ? true : false,
                  },
                  {
                    name: "Amount",
                    short_name: "Amt - INR",
                    isMulti: false,
                    value: txnAmountFilter,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("amount", val);
                      setTxnAmountFilter(val);
                    },
                    displayValue: FormatAmount({ price: txnAmountFilter }),
                    isDropdown: false,
                    isDisabled: reimbursementTxnViewAllLoading ? true : false,
                    valueType: "number",
                  },
                ],
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    value: currentStatus,
                    options: filteredStatuses.map((status) => status),
                    dropdownPlaceHolder:
                      currentStatus === "deleted"
                        ? "Discard"
                        : currentStatus === "rejected"
                          ? "Rejected"
                          : "Select status",
                    isDisabled:
                      props?.flow === "Tax_txnViewAll_popup_reject"
                        ? true
                        : currentDistributionStatus?.length >
                            GlobalConfiguration?.lengthCheckZero
                          ? true
                          : false,
                    statusPop: true,
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("lifecycle", val);
                      setCurrentStatus(val);
                      if (val === "require approval") {
                        setIsPaymentMethod("");
                        setStartDateFilter("");
                        setEndDateFilter("");
                        handleSubmit("paymentmethod", "");
                        handleSubmit("date", "");
                      }
                    },
                  },
                  {
                    name: "Distribution status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayDistributionStatus(
                      currentDistributionStatus,
                    ),
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      currentStatus?.length >
                      GlobalConfiguration?.lengthCheckZero
                        ? true
                        : false,
                    options: [
                      "distribution complete",
                      "distribution created",
                      "distribution approved",
                      "awaiting funds",
                      "distribution initiated",
                      "distribution pending",
                    ],
                    statusPop: true,
                    handleChange: handleDistributionChange,
                  },

                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value: startDateFilter && endDateFilter,
                    isDisabled: false,
                    startDate: startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration?.intervalMedium,
                        )
                      : startDateFilter,
                    endDate: endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration?.intervalMedium,
                        )
                      : endDateFilter,
                    handleChange: (date) => {
                      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                      handleFilterDateRange(date);
                    },
                  },
                  {
                    name: "Payment method",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["NEFT", "RTGS"],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: "Select type",
                    value: isPaymentMethod,
                    isDisabled: false,
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("paymentmethod", val);
                      handlePaymentMethod(val);
                    },
                    dropdownType: "PaymentMethod",
                  },
                  // {
                  //   name: "Show/hide confidential transactions",
                  //   filterType: "dropdown",
                  //   variant: "single",
                  //   isSearch: false,
                  //   options: ["Show only confidential", "Hide confidential"],
                  //   searchPlaceholder: "Search",
                  //   isDisabled:
                  //     (props.typepop == "transactionHistorypopup" ||
                  //       props.typepop == "txnHistorypopup") &&
                  //     props?.taxTxnconfidential?.length,
                  //   dropdownPlaceHolder: "Default (all transactions)",
                  //   value: isConfidentialMethod,
                  //   handleChange: (val) => {
                  //     setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  //     handleSubmit("confidential", val);
                  //     // handleConfidentialMethod(val);
                  //   },
                  // },
                  {
                    name: "Created via",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Manual", "File upload"],
                    searchPlaceholder: "Select",
                    isDisabled:
                      (props.typepop === "transactionHistorypopup" ||
                        props.typepop === "txnHistorypopup") &&
                      props?.taxTxnconfidential?.length,
                    dropdownPlaceHolder: "Select",
                    value: stateName,
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setStateName(val);
                      handleSubmit("statename", val);
                      // handleConfidentialMethod(val);
                    },
                  },
                  {
                    name: "Amount range",
                    filterType: "amountRange",
                    variant: "range",
                    size: "small",
                    rangeValue: amountLimit,
                    value: amountLimit?.max && amountLimit?.min,
                    handleChange: (val) => {
                      setAmountLimit(val);
                      if (val?.min && val?.max) {
                        handleSubmit("amountrange", `${val.min},${val.max}`);
                      }
                    },
                    setShowAmtFilterDiv: setShowAmtFilterDiv,
                    setIsAmtFilterApplied: (val) => {
                      setIsAmtFilterApplied(val);
                      if (!val) {
                        handleSubmit("amountrange", "");
                      }
                    },
                  },
                ],
                sortByFilter: [
                  {
                    name: "Newest first",
                    default: true,
                    isDisabled: false,
                  },
                  {
                    name: "Oldest first",
                    isDisabled: false,
                  },
                  {
                    name: "Amount : Low to high",
                    isDisabled: false,
                  },
                  {
                    name: "Amount : High to low",
                    isDisabled: false,
                  },
                ],
                sortValue: accountbalancestate,
                sortHandleChange: (val) => {
                  handleSubmit("sort", val);
                  setaccountbalancestate(val);
                },
                isFilterClearAllDisabled: !(
                  (startDateFilter && endDateFilter) ||
                  isPaymentMethod?.length ||
                  currentStatus?.length >
                    GlobalConfiguration?.lengthCheckZero ||
                  stateName?.length > GlobalConfiguration?.lengthCheckZero ||
                  currentDistributionStatus?.length >
                    GlobalConfiguration?.lengthCheckZero ||
                  isAmtFilterApplied
                ),

                isSearchClearAllDisabled: !(
                  (props.type !== "tax_txnViewAll_popup" &&
                    currentCategory?.length) ||
                  (props.type !== "tax_txnViewAll_popup" &&
                    props?.props?.isCategoryName?.length) ||
                  (props.type !== "tax_txnViewAll_popup" &&
                    props?.accountName?.length) ||
                  accountNameValue?.length ||
                  ownerAccId?.length ||
                  accountnumberstate?.length ||
                  (props.type !== "tax_txnViewAll_popup" &&
                    setSelectedTaxAccId?.length) ||
                  txnAmountFilter?.length ||
                  labelSearchText?.length ||
                  (startDateFilter && endDateFilter) ||
                  searchUserText?.length
                ),

                inputData: inputData,
                active: active,
                setActive: setActive,
                isSortDisabled: loading,
                isFilterDisabled: loading,
                loadingData: dataLoading,
                setLoading: (e) => {},
                isShowFilter: true,
                isShowSortBy: true,
                loading: loading,
              }}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        props.type === "tax_txnViewAll_popup" ? true : false,
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (
                          props.type === "tax_txnViewAll_popup" ||
                          props?.typepop === "rejectAllTransactionPopup"
                        ) {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                            buttonNeeded: false,
                            btnProps: {
                              enabledBgColor: "var(--primary-bg)",
                              enabledTextColor: "var(--text-primary)",
                              btnText: "",
                              handleFunction: () => {},
                              icon: "",
                              btnType: "button",
                              isDisabled: false,
                              hoverOption: "white",
                            },
                          });
                        } else {
                          if (
                            services?.includes("ALabel") &&
                            services?.includes("RLabel")
                          ) {
                            setisLabelClicked((prev) => {
                              if (prev) setLabelTransactions([]);
                              return !prev;
                            });
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "ALabel,RLabel",
                              },
                            });
                          }
                        }
                      },
                      disabledBgColor:
                        props.type === "tax_txnViewAll_popup"
                          ? ""
                          : "var(--text-primary)",
                      title:
                        "Labels will be used to generate statistics for the associated transactions.",
                    }
                  : undefined
              }
            />
          </div>

          <div
            ref={scrollContainerRef}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
              pointerEvents: showInnerSearchBar ? "none" : "",
              flex: "1",
              paddingTop:
                !showSearchBar &&
                !accumulatedData.length &&
                props?.typepop === "transactionHistorypopup" &&
                !hideCarousal
                  ? "var(--padding-md)"
                  : !accumulatedData.length &&
                      props?.typepop === "rejectAllTransactionPopup"
                    ? "var(--padding-md)"
                    : "",
            }}
            id={props?.type === "tax_txnViewAll_popup" ? "" : ""}
            tabIndex="0"
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "mb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none " : ""} ${
              props?.typepop === "rejectAllTransactionPopup" ||
              props?.type === "tax_txnViewAll_popup" ||
              showInnerSearchBar
                ? `h-full flex flex-col flex-1 overflow-hidden ${props?.type === "tax_txnViewAll_popup" && "overflow-y-auto"} min-h-0`
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0 overflow-y-auto"
            } `}
          >
            {loading ? (
              <div className="loader-container m-auto flex items-center justify-center">
                <Loader />
              </div>
            ) : accumulatedData?.length ? (
              <div
                className={`${
                  !toggleReimTxn
                    ? "standard-card-alignment"
                    : "standard-list-view-alignment"
                } gap-x-gap-sm gap-y-gap-md`}
              >
                {accumulatedData.map((transactions, index) => {
                  return !toggleReimTxn ? (
                    <div>
                      <CardContainer
                        filterRef={scrollContainerRef}
                        hoverHeight={
                          GlobalConfiguration?.reimbursementTxnCardHoverHeight
                        }
                        minHeight={GlobalConfiguration.BeneTxnCardMinHeight}
                        key={transactions?.txn_id}
                        onClickHandler={(e) => {
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (
                              props.alert === "alertpopup" ||
                              props?.flow === "Tax_txnViewAll_popup_reject"
                            ) {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                buttonNeeded: false,
                                btnProps: {
                                  enabledBgColor: "var(--primary-bg)",
                                  enabledTextColor: "var(--text-primary)",
                                  btnText: "",
                                  handleFunction: () => {},
                                  icon: "",
                                  btnType: "button",
                                  isDisabled: false,
                                  hoverOption: "white",
                                },
                              });
                            } else {
                              // CommonToast({
                              //   text: "Feature coming soon",
                              //   icon: ICONS?.ERROR_WHITE_CIRCLE,
                              //   variant: "var(--coming-soon)",
                              //   btnProps: {
                              //     isDisabled: false,
                              //     enabledTextColor: "var(--text-primary)",
                              //     enabledBgColor: "var(--primary-bg)",
                              //   },
                              // });
                              handleTransactionClick(e, transactions);
                            }
                          }
                        }}
                        isSelected={
                          Array.isArray(labelTransactions) &&
                          labelTransactions.includes(transactions?.txn_id)
                        }
                      >
                        <card-body>
                          {transactions?.amount ? (
                            <TextWithIcon
                              type="Amount"
                              isAbbrevation={true}
                              fontWeight="semibold"
                              text={transactions?.amount}
                              subText="Amount"
                              textColor="var(--settled)"
                              iconComponentArray={[
                                // Confidential transaction icon
                                ...(transactions?.confidential_transaction ===
                                "Y"
                                  ? [
                                      {
                                        icon: ICONS.CONFIDENTIAL_TRANSACTION,
                                        title: "confidential",
                                        isDisabled: false,
                                      },
                                    ]
                                  : []),

                                // Label icon
                                ...(isLabelClicked &&
                                transactions?.distribution_lifecycle_status !==
                                  "distribution_complete"
                                  ? [
                                      {
                                        icon: labelTransactions.includes(
                                          transactions?.txn_id,
                                        )
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.NOTSELECTED_WITH_GREY_CIRCLE,
                                        isDisabled: false,
                                      },
                                    ]
                                  : []),
                              ]}
                            />
                          ) : (
                            <TextWithIcon
                              type="Text"
                              fontWeight="semibold"
                              text="N/A"
                              subText="Amount"
                              textColor="var(--settled)"
                              iconComponentArray={
                                isLabelClicked &&
                                transactions?.distribution_lifecycle_status !==
                                  "distribution_complete"
                                  ? [
                                      {
                                        icon: labelTransactions.includes(
                                          transactions?.txn_id,
                                        )
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.NOTSELECTED_WITH_GREY_CIRCLE,
                                        isDisabled: false,
                                      },
                                    ]
                                  : []
                              }
                            />
                          )}

                          <TextWithIcon
                            text={
                              transactions?.tds_account_name
                                ? accountNameStandardised(
                                    transactions?.tds_account_name,
                                  )
                                : "N/A"
                            }
                            type="Text"
                            subText="Account name"
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                          />

                          <TextWithBank
                            text={
                              transactions?.created_on
                                ? formatDateViewAll(
                                    transactions.created_on,
                                    false,
                                    false,
                                  )
                                : "Not given"
                            }
                            subText="Created on"
                            type="Text"
                            src={categoryMapper(transactions?.category)}
                            ifscCode={transactions?.tds_account_ifsc_code}
                          />
                        </card-body>

                        <card-hover>
                          <TextWithIcon
                            text={
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subText="Approval status"
                            textCase="capitalize"
                            fontWeight="semibold"
                            textColor={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                          />

                          <TextWithIcon
                            text={
                              transactions?.distribution_lifecycle_status ===
                              "created"
                                ? "Distribution created"
                                : transactions?.distribution_lifecycle_status ===
                                    "awaiting_funds"
                                  ? "Awaiting funds"
                                  : transactions?.distribution_lifecycle_status ===
                                      "distribution_initiated"
                                    ? "Distribution initiated"
                                    : transactions?.distribution_lifecycle_status ===
                                        "abandoned"
                                      ? "Distribution abandoned"
                                      : transactions?.distribution_lifecycle_status ===
                                          "rejected"
                                        ? "Distribution rejected"
                                        : transactions?.distribution_lifecycle_status ===
                                            "failed"
                                          ? "Failed"
                                          : transactions?.distribution_lifecycle_status ===
                                              "distribution_complete"
                                            ? "Distribution complete"
                                            : "N/A"
                            }
                            subText="Distribution status"
                            fontWeight="semibold"
                            textColor={
                              transactions?.distribution_lifecycle_status ===
                              "N/A"
                                ? "var(--text-primary)"
                                : getDistributionColor(
                                    transactions?.distribution_lifecycle_status,
                                  )
                            }
                          />

                          <TextWithIcon
                            text={
                              transactions?.labels?.length
                                ? transactions.labels.join(", ")
                                : "Not assigned"
                            }
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                            iconComponentArray={[
                              {
                                icon: ICONS.LABEL,
                              },
                            ]}
                          />
                        </card-hover>
                      </CardContainer>
                    </div>
                  ) : (
                    <div>
                      <ListContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementTxnListHoverHeight
                        }
                        key={transactions?.txn_id}
                        filterRef={scrollContainerRef}
                        onClickHandler={(e) => {
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (
                              props.alert === "alertpopup" ||
                              props?.flow === "Tax_txnViewAll_popup_reject"
                            ) {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                buttonNeeded: false,
                                btnProps: {
                                  enabledBgColor: "var(--primary-bg)",
                                  enabledTextColor: "var(--text-primary)",
                                  btnText: "",
                                  handleFunction: () => {},
                                  icon: "",
                                  btnType: "button",
                                  isDisabled: false,
                                  hoverOption: "white",
                                },
                              });
                            } else {
                              handleTransactionClick(e, transactions);
                            }
                          }
                        }}
                        isSelected={
                          Array.isArray(labelTransactions) &&
                          labelTransactions.includes(transactions?.txn_id)
                        }
                      >
                        <list-body>
                          {/* My code new  */}
                          <div className="w-full flex justify-between pr-padding-sm py-padding-sm gap-x-gap-sm">
                            <div
                              className={`flex flex-col gap-y-gap-sm w-full`}
                            >
                              <div className="w-full flex gap-x-gap-sm">
                                <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-tr-border-radius-md rounded-br-border-radius-md">
                                  <div className="flex gap-x-gap-sm items-center">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={transactions?.tds_account_ifsc_code}
                                    />
                                    <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                                    <SVGComponent
                                      url={categoryMapper(
                                        transactions?.category,
                                      )}
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                    />
                                  </div>
                                </div>
                                <p className="overflow-hidden whitespace-nowrap overflow-ellipsis items-center text-settled text-font-xs flex-1 flex font-semibold ">
                                  <span>
                                    {"INR " +
                                      Number(
                                        transactions.amount,
                                      )?.toLocaleString("en-IN", {
                                        minimumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                        maximumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                      })}
                                  </span>
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p className="text-text-primary font-normal text-font-xs min-w-standard-account-min-width  text-right">
                                    {transactions.created_on
                                      ? formatDateViewAll(
                                          transactions.created_on,
                                          false,
                                          false,
                                        )
                                      : "Not given"}
                                  </p>

                                  {isLabelClicked &&
                                  transactions?.distribution_lifecycle_status !==
                                    "distribution_complete" ? (
                                    <SVGComponent
                                      url={
                                        labelTransactions.includes(
                                          transactions?.txn_id,
                                        )
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.NOTSELECTED_WITH_GREY_CIRCLE
                                      }
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              <div className="w-full pl-padding-sm flex justify-between items-center">
                                <p
                                  className={`text-font-xs flex-1 text-text-primary truncate font-normal`}
                                >
                                  <TickerAnimation
                                    text={
                                      transactions?.tds_account_name
                                        ? transactions.tds_account_name
                                            .toLowerCase()
                                            .replace(/\b\w/g, (char) =>
                                              char.toUpperCase(),
                                            )
                                        : "N/A"
                                    }
                                  />
                                </p>
                                <div
                                  style={{
                                    display:
                                      transactions?.confidential_transaction ===
                                      "Y"
                                        ? "flex"
                                        : "none",
                                  }}
                                  className="gap-x-gap-sm ml-margin-sm justify-end"
                                >
                                  <SVGComponent
                                    url={ICONS.CONFIDENTIAL_TRANSACTION}
                                    height={"var(--icon-sm)"}
                                    width={"var(--icon-sm)"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* My code new  */}
                        </list-body>

                        <list-hover>
                          <ListDualText
                            text1={
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subtext1="Approval status"
                            textCase1="capitalize"
                            text1FontWeight="semibold"
                            text1Color={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                            text2={
                              transactions?.distribution_lifecycle_status ===
                              "created"
                                ? "Distribution created"
                                : transactions?.distribution_lifecycle_status ===
                                    "awaiting_funds"
                                  ? "Awaiting funds"
                                  : transactions?.distribution_lifecycle_status ===
                                      "distribution_initiated"
                                    ? "Distribution initiated"
                                    : transactions?.distribution_lifecycle_status ===
                                        "abandoned"
                                      ? "Distribution abandoned"
                                      : transactions?.distribution_lifecycle_status ===
                                          "rejected"
                                        ? "Distribution rejected"
                                        : transactions?.distribution_lifecycle_status ===
                                            "failed"
                                          ? "Failed"
                                          : transactions?.distribution_lifecycle_status ===
                                              "distribution_complete"
                                            ? "Distribution complete"
                                            : "N/A"
                            }
                            subtext2="Distribution status"
                            textCase="none"
                            text2FontWeight="semibold"
                            text2Color={
                              transactions?.distribution_lifecycle_status ===
                              "N/A"
                                ? "var(--text-primary)"
                                : getDistributionColor(
                                    transactions?.distribution_lifecycle_status,
                                  )
                            }
                          />

                          <ListTextWithIcon
                            type="text"
                            text={
                              transactions?.labels?.length
                                ? transactions.labels.join(", ")
                                : "Not assigned"
                            }
                            iconComponentArray={[
                              {
                                icon: ICONS.LABEL,
                              },
                            ]}
                          />
                        </list-hover>
                      </ListContainer>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div
                className={`flex flex-col items-center justify-center m-auto mt-auto ${
                  showInnerSearchBar
                    ? "overflow-y-hidden pointer-events-none"
                    : ""
                }`}
              >
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src={
                      "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    }
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    No data found.
                  </p>
                  {clearParameterVisibility ? (
                    <div>
                      <PrimaryButton
                        enabledBgColor="var(--primary-nav-act)"
                        btnText="Clear parameters"
                        btnType="button"
                        handleFunction={handleClearParams}
                        enabledTextColor="var(--text-primary)"
                      />
                    </div>
                  ) : null}
                </div>

                {isLabelClicked ? (
                  <div
                    className={`h-navbar-breadcrumb-height mb-margin-xl block Qmd:hidden ${
                      (props?.typepop === "rejectAllTransactionPopup" ||
                        props?.typepop === "transactionHistorypopup") &&
                      "mb-margin-bottom-pop-up"
                    }`}
                  ></div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxationTransactionViewAll;
